function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { useMemo, useEffect } from "react";
import { handleCookies } from "../../cookies";
import { handleScript } from "../../scripts";
import { handleStorage } from "../../storage";
import logger from "../../../logger";
var useCookies = function(param) {
    var cookies = param.cookies;
    return useMemo(function() {
        if (cookies) {
            return handleCookies(cookies);
        }
        return {};
    }, [
        cookies
    ]);
};
var useStorage = function(param) {
    var storage = param.storage;
    return useMemo(function() {
        if (storage) {
            return handleStorage(storage);
        }
        return {};
    }, [
        storage
    ]);
};
var useScript = function(param) {
    var script = param.script;
    // Mount and execute payload-configured Federated Modules
    useEffect(function() {
        if (script) {
            handleScript(script).catch(function(error) {
                logger.error("Remote script " + script.remote + "(" + script.component + ") execution", error);
            });
        }
    }, [
        script
    ]);
};
var useJSONEffect = function(content) {
    // Read and provide payload-configured cookies as props
    var requestedCookieValues = useCookies(content);
    // Read and provide payload-configured localStorage values as props
    var requestedStorageValues = useStorage(content);
    useScript(content);
    return useMemo(function() {
        return _extends({}, requestedCookieValues, requestedStorageValues);
    }, [
        requestedCookieValues,
        requestedStorageValues
    ]);
};
export default useJSONEffect;

//# sourceMappingURL=useJSONEffect.js.map